import React, { useState, useEffect,useCallback } from "react";
import { FaSave, FaPlus } from "react-icons/fa";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import panelimg from "../Assets/icons/VT-5000.png";
import CloudProLoopTable from "./CloudProLoopTable";
import defaultPanelData from "../Assets/defaultPanelData/defaultPanelData.json";
import Axios from "axios";
import CloudProConfigFile from "./CloudProConfigFile";
import { useParams, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import CloudProVTNETFrame from "./CloudProVTNETFrame";
import { Snackbar, Alert } from "@mui/material";
import { useRef } from "react";
import { panelFromProjectDocument } from "./workflowPanelData";

const CloudProPanelConfig = () => {

  const { mdId } = useParams();
  const siId = localStorage.getItem("siId") || "";
  const [selectedProject, setSelectedProject] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [panelName, setPanelName] = useState("");
  const [selectedLoop, setSelectedLoop] = useState(0);
  const [selectedPanel, setSelectedPanel] = useState(null);
  const [activeLoopIndex, setActiveLoopIndex] = useState(null);
  const [apiPanels, setApiPanels] = useState([]);
  const [panelsLoading, setPanelsLoading] = useState(false);
  const [showImportPopup, setShowImportPopup] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("success");
  const location = useLocation();
  const [workflowPanels, setWorkflowPanels] = useState([]);
  const [workflowDevices, setWorkflowDevices] = useState([]);
  const panelLoadRequest = useRef(0);
  const [panelRefreshSeq, setPanelRefreshSeq] = useState(0);
  useEffect(() => {
    const refresh = () => setPanelRefreshSeq(n => n + 1);
    window.addEventListener("project-refreshed", refresh);
    return () => window.removeEventListener("project-refreshed", refresh);
  }, []);
  const [workflowRevision, setWorkflowRevision] = useState(null);
  const [workflowLoading, setWorkflowLoading] = useState(false);
  const [workflowOptions, setWorkflowOptions] = useState({
    locations: [],
    zones: [],
    outputZones: [],
  });
  const [loading, setLoading] = useState(false);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    panel: null,
  });
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [panelToAction, setPanelToAction] = useState(null);
  const [editPanelName, setEditPanelName] = useState("");
  const [editSaving, setEditSaving] = useState(false);
  const [deleteSaving, setDeleteSaving] = useState(false);
  const contextMenuRef = useRef(null);
  const [editLoopCount, setEditLoopCount] = useState(0);

const fetchWorkflowDevices = useCallback(async ({ silent = false } = {}) => {
  if (!selectedProject?.project_id) return;
  try {
    if (!silent) setWorkflowLoading(true);

    const response = await Axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/cause-effect-workflow/devices/list`,
      {
        email: localStorage.getItem("userEmail"),
        projectId: selectedProject.project_id,
      }
    );
    const result = response.data;

    setWorkflowRevision(result?.revision ?? null);

    const panels = Array.isArray(result?.panels)
      ? result.panels.map((panel) => ({
          ...panel,
          displayName: (panel.name || "Unnamed Panel").replace(/\u0000/g, "").trim(),
        }))
      : [];
    setWorkflowPanels(panels);

    setSelectedPanel((prev) =>
      prev ? panels.find((p) => p.panelContentId === prev.panelContentId) || null : prev
    );

    setWorkflowDevices(Array.isArray(result?.devices) ? result.devices : []);
    setWorkflowOptions({
      locations: result?.options?.locations || [],
      zones: result?.options?.zones || [],
      outputZones: result?.options?.outputZones || [],
    });

    if (result?.revision != null) {
      sessionStorage.setItem("causeEffectRevision", String(result.revision));
    }
  } catch (error) {
    if (!silent) {
      setWorkflowPanels([]);
      setWorkflowDevices([]);
    }
  } finally {
    if (!silent) setWorkflowLoading(false);
  }
}, [selectedProject?.project_id]);

useEffect(() => {
  fetchWorkflowDevices();
}, [fetchWorkflowDevices]);

useEffect(() => {
  const panelContentId = selectedPanel?.panelContentId;
  const projectId = selectedProject?.project_id;
  const request = ++panelLoadRequest.current;
  if (!projectId || !panelContentId) return;
  Axios.post("/get_customer_panel", { mdId, siId, projectId, panelContentId })
    .then(({ data }) => {
      if (request !== panelLoadRequest.current) return;
      if (!data?.success || !data.panel) throw new Error(data?.msg || "Panel not found");
      const fullPanel = panelFromProjectDocument(data.panel, selectedPanel);
      console.log("Selected panel (complete project data):", fullPanel);
      setSelectedPanel(fullPanel);
      setPanelCache(prev => ({ ...prev, [panelContentId]: fullPanel }));
      setSelectedProject(prev => {
        if (!prev || prev.project_id !== projectId) return prev;
        const updated = { ...prev, panel: fullPanel };
        sessionStorage.setItem("selectedProject", JSON.stringify(updated));
        sessionStorage.setItem("panelContentId", panelContentId);
        return updated;
      });
    })
    .catch(error => {
      if (request === panelLoadRequest.current) console.error("Failed to load full panel:", error);
    });
}, [mdId, siId, selectedProject?.project_id, selectedPanel?.panelContentId, panelRefreshSeq]);
  useEffect(() => {
    if (
      !selectedProject?.project_id ||
      workflowLoading ||
      workflowPanels.length === 0 ||
      selectedPanel
    ) {
      return;
    }

    const savedFileId = sessionStorage.getItem("causeEffectFileId");
    const savedPanelNumber = Number(sessionStorage.getItem("causeEffectPanelNumber"));

    const panelToSelect =
      workflowPanels.find((panel) => panel.fileId === savedFileId && panel.panelNumber === savedPanelNumber) ||
      workflowPanels[0];

    if (!panelToSelect) return;

   
    setSelectedPanel(panelToSelect);

    sessionStorage.setItem(
      "causeEffectPanelNumber",
      String(panelToSelect.panelNumber)
    );

    sessionStorage.setItem(
      "causeEffectFileId",
      panelToSelect.fileId
    );


    const savedLoops = JSON.parse(
      sessionStorage.getItem("selectedLoops") || "{}"
    );

    const savedLoop = savedLoops[panelToSelect.fileId];

    const loopIndex =
      savedLoop !== undefined
        ? savedLoop
        : Array.isArray(panelToSelect.loops) &&
          panelToSelect.loops.length > 0
          ? panelToSelect.loops[0] - 1
          : 0;

    setActiveLoopIndex(loopIndex);
  }, [
    selectedProject?.project_id,
    workflowLoading,
    workflowPanels,
    selectedPanel,
  ]);


  useEffect(() => {
    if (!selectedPanel) return;

    const selectedLoops =
      JSON.parse(sessionStorage.getItem("selectedLoops")) || {};

    const panelKey =
      selectedPanel.fileId || selectedPanel.panelContent_id;

    if (selectedLoops[panelKey] !== undefined) {
      setActiveLoopIndex(selectedLoops[panelKey]);
      return;
    }


    if (
      Array.isArray(selectedPanel.loops) &&
      selectedPanel.loops.length > 0
    ) {
      setActiveLoopIndex(selectedPanel.loops[0] - 1);
    } else {
      setActiveLoopIndex(0);
    }
  }, [selectedPanel]);
  useEffect(() => {
    const img = new Image();
    img.src = panelimg;
  }, []);

    useEffect(() => {
    if (!selectedProject?.project_id) return;

    const fetchWorkflowDevices = async () => {
      try {
        setWorkflowLoading(true);

        const projectId = selectedProject.project_id;
        const userEmail = localStorage.getItem("userEmail");

        const response = await Axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/cause-effect-workflow/devices/list`,
          {
            email: userEmail,
            projectId,
          }
        );

        const result = response.data;

        setWorkflowRevision(result?.revision ?? null);

        setWorkflowPanels(
          Array.isArray(result?.panels)
            ? result.panels.map((panel) => ({
              ...panel,
              displayName: (panel.name || "Unnamed Panel")
                .replace(/\u0000/g, "")
                .trim(),
            }))
            : []
        );

        setWorkflowDevices(
          Array.isArray(result?.devices)
            ? result.devices
            : []
        );
        setWorkflowOptions({
          locations: Array.isArray(result?.options?.locations)
            ? result.options.locations
            : [],

          zones: Array.isArray(result?.options?.zones)
            ? result.options.zones
            : [],

          outputZones: Array.isArray(result?.options?.outputZones)
            ? result.options.outputZones
            : [],
        });
        if (result?.revision != null) {
          sessionStorage.setItem(
            "causeEffectRevision",
            String(result.revision)
          );
        }
      } catch (error) {

        setWorkflowPanels([]);
        setWorkflowDevices([]);
      } finally {
        setWorkflowLoading(false);
      }
    };

    fetchWorkflowDevices();
  }, [selectedProject?.project_id]);
  useEffect(() => {
    const storedProject = sessionStorage.getItem("selectedProject");
    if (storedProject) {
      try {
        const parsedProject = JSON.parse(storedProject);
        console.log("Loaded Project:", parsedProject);
        const PanelNumber = parsedProject?.panel?.VT5000_CONFIG?.panel_number;

        setSelectedProject(parsedProject);
        setProjectName(parsedProject?.name || "");
        setPanelName(
          parsedProject?.panel?.VT5000_CONFIG?.GeneralParameters?.panelName?.replace(/\u0000/g, '') || ""
        );
      } catch (e) {
        console.error("Failed to parse stored project:", e);
        setAlertType("error");
        setOpenSnackbar(true);
        setAlertMsg("Failed to parse stored project:", e);
      }
    }
  }, []);
  useEffect(() => {
    if (!selectedProject?.project_id) return;
    const fetchProject = async () => {
      setPanelsLoading(true);
      try {
        const res = await Axios.post("/get_customer_project", {
          mdId: mdId,
          projectId: selectedProject.project_id,
        });
        if (res.data.success) {
          const variants = res.data.projectVariants || [];

          if (variants.length > 0) {
            sessionStorage.setItem(
              "updatedPanelContentId",
              variants[0].panelContent_id
            );
          }
          const mappedPanels = variants.map((p, index) => ({

            id: p.panelContent_id || index,
            name: (p.panelName || "Unnamed Panel").replace(/\u0000/g, "").trim(),
            panelContent_id: p.panelContent_id,
            panel_number: p.panel_number,
            last_modify_time: p.last_modify_time,
            VT5000_CONFIG: {
              ...p.panel,
              GeneralParameters: {
                ...p.panel?.GeneralParameters,
                loopCardNb:
                  p.panel?.GeneralParameters?.loopCardNb ?? 0
              },
            },
          }));
          setApiPanels(mappedPanels);

        }
      } catch (err) {
        console.error(err);
        setAlertType("error");
        setOpenSnackbar(true);
        setAlertMsg(err);
      }
      finally {
        setPanelsLoading(false);
      }
    };
    fetchProject();
  }, [selectedProject?.project_id]);

  useEffect(() => {
    if (!contextMenu.visible) return;
    const closeMenu = (e) => {
      if (contextMenuRef.current && contextMenuRef.current.contains(e.target)) {
        return;
      }
      setContextMenu((prev) => ({ ...prev, visible: false }));
    };
    window.addEventListener("click", closeMenu);
    window.addEventListener("scroll", closeMenu, true);
    return () => {
      window.removeEventListener("click", closeMenu);
      window.removeEventListener("scroll", closeMenu, true);
    };
  }, [contextMenu.visible]);

  const handleAssignmentSaved = (assignment, revision) => {
    setWorkflowDevices((prev) =>
      prev.map((d) =>
        d.deviceId === assignment.deviceId
          ? { ...d, assignment: { ...d.assignment, ...assignment } }
          : d
      )
    );
    if (revision != null) setWorkflowRevision(revision);
  };

  const handleImportDone = useCallback(
    async (importedFileId) => {
   
      if (importedFileId) {
        sessionStorage.setItem("causeEffectFileId", importedFileId);
      } else {
        sessionStorage.removeItem("causeEffectFileId");
      }
      sessionStorage.removeItem("causeEffectPanelNumber");

      setSelectedPanel(null);
      setActiveLoopIndex(null);

      await fetchWorkflowDevices({ silent: true });
    },
    [fetchWorkflowDevices]
  );
  const handleEditClick = () => {
    const panel = contextMenu.panel;
    if (!panel) return;
    setPanelToAction(panel);
    setEditPanelName(
      panel?.name ||
      panel?.VT5000_CONFIG?.GeneralParameters?.panelName?.replace(/\u0000/g, "") ||
      ""
    );
    const fullPanel =
      selectedPanel?.panelContent_id === panel.panelContent_id
        ? selectedPanel
        : panelCache[panel.panelContent_id] || panel;

    const currentLoopCount =
      fullPanel?.VT5000_CONFIG?.GeneralParameters?.loopCardNb ??
      fullPanel?.VT5000_CONFIG?.generalparameters?.loopCardNb ??
      0;



    setEditLoopCount(Number(currentLoopCount));

    setShowEditPopup(true);
    setContextMenu((prev) => ({ ...prev, visible: false }));
  };

  const handleDeleteClick = () => {
    const panel = contextMenu.panel;
    if (!panel) return;
    setPanelToAction(panel);
    setShowDeleteConfirm(true);
    setContextMenu((prev) => ({ ...prev, visible: false }));
  };


  const handleSaveEditPanel = async () => {
    if (!panelToAction || !editPanelName.trim()) return;

    const updatedName = editPanelName.trim();
    const updatedGeneralParameters = {
      ...selectedPanel?.VT5000_CONFIG?.generalparameters,
      panelName: updatedName,
      loopCardNb: editLoopCount,
    };
    try {
      await Axios.post("/update_panel_generalparameters", {
        projectId: selectedProject.project_id,
        panelContentId: panelToAction.panelContent_id,
        email: localStorage.getItem("userEmail"),
        generalparameters: updatedGeneralParameters,
      });

      
      setApiPanels((prev) =>
        prev.map((panel) =>
          panel.panelContent_id === panelToAction.panelContent_id
            ? {
              ...panel,
              name: updatedName,
              VT5000_CONFIG: {
                ...panel.VT5000_CONFIG,
                GeneralParameters: {
                  ...panel.VT5000_CONFIG?.GeneralParameters,
                  panelName: updatedName,
                  loopCardNb: editLoopCount,
                },
              },
            }
            : panel
        )
      );

      setSelectedPanel((prev) => ({
        ...prev,
        name: updatedName,
        VT5000_CONFIG: {
          ...prev.VT5000_CONFIG,
          GeneralParameters: {
            ...prev.VT5000_CONFIG.GeneralParameters,
            panelName: updatedName,
            loopCardNb: editLoopCount,
          },
        },
      }));
      setPanelCache((prev) => ({
        ...prev,
        [panelToAction.panelContent_id]: {
          ...prev[panelToAction.panelContent_id],
          name: updatedName,
          VT5000_CONFIG: {
            ...prev[panelToAction.panelContent_id]?.VT5000_CONFIG,
            GeneralParameters: {
              ...prev[panelToAction.panelContent_id]?.VT5000_CONFIG?.GeneralParameters,
              panelName: updatedName,
              loopCardNb: editLoopCount,
            },
          },
        },
      }));
      setAlertType("success");
      setOpenSnackbar(true);
      setAlertMsg("Panel updated successfully!");
    } catch (err) {
      console.error(err);
      setAlertType("error");
      setOpenSnackbar(true);
      setAlertMsg("Failed to update panel");
    }

    setShowEditPopup(false);
    setPanelToAction(null);
  };
 

  const handleConfirmDelete = async () => {
    if (!panelToAction) return;
    setDeleteSaving(true);
    try {
      const response = await Axios.post("/delete_customer_panel", {
        mdId,
        siId,
        projectId: selectedProject?.project_id,
        panelContentId: panelToAction.panelContent_id,
      });
      const data = response.data;
      if (!data.success) {
        setAlertType("error");
        setOpenSnackbar(true);
        setAlertMsg(data.msg || "Failed to delete panel");
        return;
      }

      setApiPanels((prev) =>
        prev.filter((p) => p.panelContent_id !== panelToAction.panelContent_id)
      );

      setPanelCache((prev) => {
        const updated = { ...prev };
        delete updated[panelToAction.panelContent_id];
        return updated;
      });

     
      if (selectedPanel?.panelContent_id === panelToAction.panelContent_id) {
        setSelectedPanel(null);
        setActiveLoopIndex(null);
        sessionStorage.removeItem("panelContentId");
      }
      setSelectedProject((prev) => {
        if (!prev) return prev;
        const updatedProject = {
          ...prev,
          panels: (prev.panels || []).filter(
            (p) => p.panelContent_id !== panelToAction.panelContent_id
          ),
        };
        sessionStorage.setItem("selectedProject", JSON.stringify(updatedProject));
        return updatedProject;
      });

      setAlertType("success");
      setOpenSnackbar(true);
      setAlertMsg("Panel deleted successfully!");
      setShowDeleteConfirm(false);
      setPanelToAction(null);
    } catch (error) {
      console.error("Error deleting panel:", error);
      setAlertType("error");
      setOpenSnackbar(true);
      setAlertMsg(error?.response?.data?.msg || "Error deleting panel");
    } finally {
      setDeleteSaving(false);
    }
  };



  const handleSavePanel = async () => {
    if (!panelName.trim()) return;
    const existingPanels = selectedProject?.panels || [];
    const isDuplicate = [
      ...(selectedProject?.panel ? [selectedProject.panel] : []),
      ...existingPanels,
    ].some(
      (p) =>
        (p?.name ||
          p?.VT5000_CONFIG?.GeneralParameters?.panelName)
          ?.toLowerCase()
          .trim() === panelName.toLowerCase().trim()
    );
    if (isDuplicate) {
      setAlertType("success");
      setOpenSnackbar(true);
      setAlertMsg("Panel name already exists!");
      return;
    }
    const newPanelData = JSON.parse(JSON.stringify(defaultPanelData));

    newPanelData.GeneralParameters = newPanelData.GeneralParameters || {};
    newPanelData.GeneralParameters.panelName = panelName.trim();
    newPanelData.GeneralParameters.loopCardNb = selectedLoop;
    const userEmail = localStorage.getItem("userEmail");
    try {
      const response = await Axios.post("/add_customer_panel", {
        mdId: mdId,
        siId: siId,
        email: userEmail,
        panelName: panelName.trim(),
        projectId: selectedProject?.project_id,
        panel: newPanelData,
      });
      const data = response.data;
      if (!data.success) {
        setAlertType("error");
        setOpenSnackbar(true);
        setAlertMsg(data.msg || "Failed to save panel");
        return;
      }

      const newPanelUI = {
        id: data.panel_id || Date.now(),
        name: (data.panelName || panelName).replace(/\u0000/g, "").trim(),
        VT5000_CONFIG: data.panel || newPanelData,
        panelContent_id: data.panelContent_id,
        panelDevice_id: data.panelDevice_id,
      };
      setApiPanels((prev) => [...prev, newPanelUI]);

      const updatedPanels = [...existingPanels, newPanelUI];


      const updatedProject = {
        ...selectedProject,
        panels: updatedPanels,
      };
      sessionStorage.setItem("selectedProject", JSON.stringify(updatedProject));
      setSelectedProject({ ...updatedProject });
      setSelectedPanel(newPanelUI);
      setActiveLoopIndex(0);
      setPanelName("");
      setSelectedLoop(0);
      setShowPopup(false);
      setAlertType("success");
      setOpenSnackbar(true);
      setAlertMsg("Panel saved successfully!");
    } catch (error) {
      console.error("Error saving panel:", error);
      setAlertType("error");
      setOpenSnackbar(true);
      setAlertMsg("Error saving panel:", error);
    }
  };
  const [panelCache, setPanelCache] = useState({});
  const [showComponent, setShowComponent] = useState(false);

  const currentPanelCount = apiPanels.length;

  const maxPanelCount = selectedProject?.panel?.VT5000_CONFIG?.panel_number || 0;

  const disableAddPanel = currentPanelCount >= maxPanelCount;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress />
        </div>
      )}
      {!selectedProject ? (
        <div style={{ padding: "20px", color: "red", textAlign: "center" }}>
          Please select a project first
        </div>
      ) : (
        <div className="project-container">
          <div className="glass-card">
            <Card sx={{ minWidth: 275 }}>
              <CardContent>
                <div className="header">
                  <div className="left-actions">
                  </div>
                  <div className="right-actions"

                  >
                    <button className="btn add" onClick={() => setShowImportPopup(true)}>
                      Import Config
                    </button>
                    {/* <button className="btn csv" disabled={disableAddPanel}
                      style={{
                        opacity: disableAddPanel ? 0.5 : 1,
                        cursor: disableAddPanel ? "not-allowed" : "pointer",
                      }} onClick={() => {
                        setShowPopup(true);
                        setProjectName(selectedProject?.name || "");
                        setPanelName("");
                      }}>
                      <FaPlus /> Add Panel
                    </button> */}

                    <button className="btn blue" disabled={!selectedPanel}
                      style={{
                        opacity: selectedPanel ? 1 : 0.5,
                        cursor: selectedPanel ? "pointer" : "not-allowed",
                      }} onClick={() => setShowComponent(true)}>
                      VT-NET
                    </button>
                    {showComponent && (
                      <div className="popup">
                        <div className="popup-content">

                          <CloudProVTNETFrame project={selectedProject} setShowComponent={setShowComponent} />

                        </div>
                      </div>
                    )}
                    {showImportPopup && (
                      <CloudProConfigFile
                        onClose={() => setShowImportPopup(false)}
                         onImported={handleImportDone}
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                        setApiPanels={setApiPanels}
                        setSelectedPanel={setSelectedPanel}
                        setPanelCache={setPanelCache}
                      />
                    )}
                  </div>
                </div>
                {selectedProject && (
                  <div >
                    <h6 style={{ color: "red", cursor: "pointer", marginTop: isMobile ? 0 : "-30px" }}
                      onClick={() => {
                        setSelectedProject(selectedProject); setSelectedPanel(null);
                        setActiveLoopIndex(null)
                      }}>
                      {selectedProject.name}
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        width: "70%",
                        overflowX: "auto",
                        paddingBottom: "10px",
                      }}
                    >
                      {workflowLoading ? (
                        <div style={{ padding: "20px" }}>
                          Loading panels...
                        </div>
                      ) : workflowPanels.length === 0 ? (
                        <div style={{ padding: "20px" }}>
                          No panels found
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            gap: "12px",
                            flexWrap: "wrap",
                          }}
                        >
                          {workflowPanels.map((panel) => (
                            <div
                              key={panel.panelContentId}
                              onClick={() => {
                                sessionStorage.setItem(
                                  "causeEffectPanelNumber",
                                  String(panel.panelNumber)
                                );

                                sessionStorage.setItem(
                                  "causeEffectFileId",
                                  panel.fileId
                                );

                                setSelectedPanel(panel);

                                const selectedLoops =
                                  JSON.parse(
                                    sessionStorage.getItem("selectedLoops")
                                  ) || {};

                                const savedLoop =
                                  selectedLoops[panel.fileId] ?? 0;

                                setActiveLoopIndex(savedLoop);
                              }}
                              style={{
                                width: "100px",
                                cursor: "pointer",
                                border:
                                  selectedPanel?.panelContentId === panel.panelContentId
                                    ? "2px solid red"
                                    : "1px solid #ccc",
                                borderRadius: "8px",
                                padding: "8px",
                                textAlign: "center",
                                background: "#fff",
                              }}
                            >
                              {/* PANEL IMAGE */}
                              <img
                                src={panelimg}
                                alt={panel.displayName || "Panel"}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "contain",
                                  display: "block",
                                  margin: "0 auto 6px",
                                }}
                              />

                              {/* PANEL NAME */}
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  wordBreak: "break-word",
                                }}
                              >
                                {panel.displayName}
                              </div>

                              {/* PANEL NUMBER */}
                              <div
                                style={{
                                  fontSize: "11px",
                                  color: "#666",
                                  marginTop: "3px",
                                }}
                              >
                                Panel {panel.panelNumber}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {selectedPanel && (
                      <div >
                        <h6>
                          Loops for{" "}
                          {selectedPanel?.displayName ||
                            selectedPanel?.name?.replace(/\u0000/g, "").trim() ||
                            "Panel"}
                        </h6>
                        {(() => {
                          const workflowLoops = Array.isArray(selectedPanel?.loops)
                            ? selectedPanel.loops
                            : [];

                          sessionStorage.setItem(
                            "selectedPanel",
                            JSON.stringify(selectedPanel?.displayName || selectedPanel?.name || "")
                          );

                          return (
                            <div style={{ display: "flex", gap: "10px" }}>
                              {workflowLoops.map((loopNumber) => (
                                <div
                                  key={loopNumber}
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                    border: "1px solid red",
                                    backgroundColor:
                                      activeLoopIndex === loopNumber - 1
                                        ? "red"
                                        : "white",
                                    color:
                                      activeLoopIndex === loopNumber - 1
                                        ? "white"
                                        : "red",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    const loops =
                                      JSON.parse(
                                        sessionStorage.getItem("selectedLoops")
                                      ) || {};

                                    loops[selectedPanel.fileId] = loopNumber - 1;

                                    sessionStorage.setItem(
                                      "selectedLoops",
                                      JSON.stringify(loops)
                                    );

                                    setActiveLoopIndex(loopNumber - 1);
                                  }}
                                >
                                  {loopNumber}
                                </div>
                              ))}
                            </div>
                          );
                        })()}

                        {activeLoopIndex !== null && selectedPanel && (
                          <CloudProLoopTable
                            key={`${selectedPanel?.fileId}-${activeLoopIndex}`}
                            loopNumber={activeLoopIndex}
                            panel={selectedPanel}
                            project={selectedProject}
                            setSelectedProject={setSelectedProject}
                            setPanelCache={setPanelCache}
                            workflowDevices={workflowDevices}
                            workflowPanelNumber={selectedPanel?.panelNumber}
                            workflowOptions={workflowOptions}
                            onAssignmentSaved={handleAssignmentSaved}
                            onRefresh={() => fetchWorkflowDevices({ silent: true })}
                          />
                        )}

                      </div>
                    )}
                  </div>
                )}
                {showPopup && (
                  <div className="popup">
                    <div className="popup-content">
                      <h6>Add Panel</h6>

                      <input
                        placeholder="Project Name"
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)} readOnly
                      />

                      <input
                        placeholder="Panel Name"
                        value={panelName}
                        onChange={(e) => setPanelName(e.target.value)}
                      />

                      <p>Select Loop Card</p>

                      <div style={{ display: "flex", gap: "10px" }} className="loop-container">
                        {[0, 1, 2, 3, 4].map((loop) => (
                          <div className={`loop-card ${selectedLoop === loop ? "selected" : ""}`}
                            key={loop}
                            onClick={() => setSelectedLoop(loop)}
                         
                          >
                            <div className="loop-circle">{loop}</div>
                          </div>
                        ))}
                      </div>

                      <div className="popup-actions">
                        <button onClick={handleSavePanel} className="add-btn">
                          <FaSave /> Save
                        </button>
                        <button onClick={() => setShowPopup(false)} className="cancel-btn">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}

              </CardContent>
            </Card>
            {contextMenu.visible && (
              <div
                ref={contextMenuRef}
                style={{
                  position: "fixed",
                  top: contextMenu.y,
                  left: contextMenu.x,
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  zIndex: 10000,
                  minWidth: "120px",
                  overflow: "hidden",
                }}
              >
                <div
                  onClick={handleEditClick}
                  style={{
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontSize: "13px",
                    borderBottom: "1px solid #eee",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  Edit
                </div>
                <div
                  onClick={handleDeleteClick}
                  style={{
                    padding: "8px 14px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: "red",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  Delete
                </div>
              </div>
            )}

           
          </div>
        </div>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={alertType}
          variant="filled"
        >
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  )
}
export default CloudProPanelConfig;
